import type { Config } from 'wagmi'

const walletErrorNames = new Set([
  'Error',
  'BaseError',
  'ConnectorNotConnectedError',
  'ConnectorChainMismatchError',
  'UserRejectedRequestError',
  'TransactionExecutionError',
  'ContractFunctionExecutionError',
  'RpcRequestError',
  'SwitchChainError',
])

// Provider error messages can contain full calldata; record only known types and numeric RPC codes.
export const getWalletErrorSummary = (error: unknown) => {
  const causes: { code?: number; name: string }[] = []
  let current = error
  for (let depth = 0; depth < 3 && current && typeof current === 'object'; depth++) {
    const { cause, code, name } = current as { cause?: unknown; code?: unknown; name?: unknown }
    causes.push({
      ...(typeof code === 'number' && Number.isFinite(code) ? { code } : {}),
      name: typeof name === 'string' && walletErrorNames.has(name) ? name : 'WalletRequestError',
    })
    current = cause
  }
  return causes
}

export const getWalletConnectionState = (config: Config) => {
  const { chainId, connections, current, status } = config.state
  const connection = current ? connections.get(current) : undefined
  return {
    connectedChainId: connection?.chainId,
    connectionCount: connections.size,
    connectorId: connection?.connector.id,
    connectorUid: current,
    selectedChainId: chainId,
    status,
  }
}

export const assertWalletConnection = (config: Config) => {
  const { connections, current, status } = config.state
  const connection = current ? connections.get(current) : undefined
  if (status === 'connecting' || status === 'reconnecting') {
    throw new Error('Your manager wallet is still connecting in UFarm. Wait for it to connect, then retry the request.')
  }
  if (status !== 'connected' || !connection?.accounts.length) {
    throw new Error(
      'Reconnect your manager wallet in UFarm, then retry the request. Your dApp session is still active.',
    )
  }
}
